import { render, staticRenderFns } from "./miniUniverse.vue?vue&type=template&id=6addd7d9&scoped=true"
import script from "./miniUniverse.vue?vue&type=script&lang=js"
export * from "./miniUniverse.vue?vue&type=script&lang=js"
import style0 from "./miniUniverse.vue?vue&type=style&index=0&id=6addd7d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6addd7d9",
  null
  
)

export default component.exports